export default __webpack_public_path__ + "static/automotive-header-60edc50cec8ae519a82439c7e58d6674.jpg";